import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deleteUserEmail = defineEndpoint({
  method: 'DELETE',
  path: '/v1/user-emails/:emailId',
  params: z.object({ emailId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
